(() => {
  const root = document.querySelector('.zp[data-section-id]');
  if (!root) return;

  const money = (cents) => {
    try {
      if (window.Shopify?.formatMoney) {
        return Shopify.formatMoney(cents, theme?.moneyFormat || '{{amount}}');
      }
    } catch (_) {}
    const n = (Number(cents) / 100).toFixed(2);
    return `₹${n.replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

/* ---------- Gallery ---------- */

const thumbs = [...root.querySelectorAll('[data-thumb-index]')];
const slides = [...root.querySelectorAll('[data-slide-index]')];
const stage = root.querySelector('[data-zoom-stage]');

let currentIndex = 0;

const setSlide = (index) => {
  if (!slides.length) return;

  // Infinite gallery
  if (index < 0) {
    index = slides.length - 1;
  }

  if (index >= slides.length) {
    index = 0;
  }

  currentIndex = index;

  thumbs.forEach((t, i) => {
    t.classList.toggle('is-active', i === index);
    t.setAttribute(
      'aria-selected',
      i === index ? 'true' : 'false'
    );
  });

  slides.forEach((s, i) => {
    s.classList.toggle('is-active', i === index);
  });
};


/* Thumbnail support remains available internally */
thumbs.forEach((t) => {
  t.addEventListener('click', () => {
    setSlide(Number(t.dataset.thumbIndex));
  });
});


/* =========================================================
   SWIPE / DRAG GALLERY
   Mobile: finger swipe
   Desktop: mouse drag
   ========================================================= */

if (stage && slides.length > 1) {

  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let dragging = false;

  const swipeThreshold = 45;

  const prevButton = root.querySelector('[data-gallery-prev]');
const nextButton = root.querySelector('[data-gallery-next]');

if (prevButton) {
  prevButton.addEventListener('click', (event) => {
    event.stopPropagation();
    setSlide(currentIndex - 1);
  });
}

if (nextButton) {
  nextButton.addEventListener('click', (event) => {
    event.stopPropagation();
    setSlide(currentIndex + 1);
  });
}


  /* ---------- Touch ---------- */

  stage.addEventListener(
    'touchstart',
    (event) => {

      if (!event.touches.length) return;

      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;

    },
    { passive: true }
  );


  stage.addEventListener(
    'touchend',
    (event) => {

      if (!event.changedTouches.length) return;

      const endX = event.changedTouches[0].clientX;
      const endY = event.changedTouches[0].clientY;

      const deltaX = endX - startX;
      const deltaY = endY - startY;

      /*
       * Only treat it as a gallery swipe when
       * horizontal movement is stronger than vertical movement.
       */
      if (
        Math.abs(deltaX) > swipeThreshold &&
        Math.abs(deltaX) > Math.abs(deltaY)
      ) {

        if (deltaX < 0) {
          // Swipe left → next image
          setSlide(currentIndex + 1);
        } else {
          // Swipe right → previous image
          setSlide(currentIndex - 1);
        }

      }

    },
    { passive: true }
  );


  /* ---------- Desktop mouse drag ---------- */

  stage.addEventListener('mousedown', (event) => {

    /*
     * Don't start dragging when clicking the zoom button.
     */
    if (event.target.closest('[data-zoom-open]')) return;

    startX = event.clientX;
    currentX = event.clientX;
    dragging = true;

    stage.classList.add('is-dragging');

  });


  window.addEventListener('mousemove', (event) => {

    if (!dragging) return;

    currentX = event.clientX;

  });


  window.addEventListener('mouseup', () => {

    if (!dragging) return;

    const deltaX = currentX - startX;

    dragging = false;

    stage.classList.remove('is-dragging');

    if (Math.abs(deltaX) < swipeThreshold) return;

    if (deltaX < 0) {
      // Drag left → next
      setSlide(currentIndex + 1);
    } else {
      // Drag right → previous
      setSlide(currentIndex - 1);
    }

  });


  /* Prevent accidental image dragging */
  stage.addEventListener('dragstart', (event) => {
    event.preventDefault();
  });

}

  /* ---------- Lightbox ---------- */
  const lightbox = root.querySelector('[data-lightbox]');
  const lightboxImg = root.querySelector('[data-lightbox-img]');
  const openZoom = root.querySelector('[data-zoom-open]');
  const closeZoom = root.querySelector('[data-lightbox-close]');

  const openLightbox = () => {
    const active = root.querySelector('.zp-slide.is-active img');
    if (!active || !lightbox) return;
    lightboxImg.src = active.currentSrc || active.src;
    lightboxImg.alt = active.alt || '';
    lightbox.hidden = false;
    requestAnimationFrame(() => lightbox.classList.add('is-open'));
  };
  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    setTimeout(() => { lightbox.hidden = true; }, 320);
  };
  openZoom?.addEventListener('click', openLightbox);
  closeZoom?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (e) => {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLightbox();
  });

  /* ---------- Demo color / size (no variants) ---------- */
  root.querySelectorAll('[data-demo-color]').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-demo-color]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      const label = root.querySelector('[data-color-label]');
      if (label) label.textContent = btn.dataset.demoColor;
    });
  });
  root.querySelectorAll('[data-demo-size]').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-demo-size]').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  /* ---------- Variant options ---------- */
  const productJsonEl = root.querySelector('[data-product-json]');
  let product = null;
  try { product = JSON.parse(productJsonEl?.textContent || 'null'); } catch (_) {}

  const selected = {};
  if (product?.options) {
    product.options.forEach((name, i) => {
      const active = root.querySelector(`[data-option-position="${i + 1}"].is-active`);
      selected[name] = active?.dataset.optionValue || product.variants?.[0]?.[`option${i + 1}`];
    });
  }

  const findVariant = () => {
    if (!product?.variants) return null;
    return product.variants.find((v) =>
      product.options.every((name, i) => v[`option${i + 1}`] === selected[name])
    );
  };

  const updateBuybox = (variant) => {
    if (!variant) return;
    const idInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const badgeEl = root.querySelector('[data-badge]');
    const atc = root.querySelector('[data-add-to-cart]');
    const atcLabel = root.querySelector('[data-atc-label]');
    const row = root.querySelector('[data-price-row]');

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);

    const onSale = variant.compare_at_price > variant.price;
    if (onSale) {
      if (compareEl) {
        compareEl.hidden = false;
        compareEl.textContent = money(variant.compare_at_price);
      } else if (row && !root.querySelector('[data-compare]')) {
        const c = document.createElement('span');
        c.className = 'zp-compare';
        c.dataset.compare = '';
        c.textContent = money(variant.compare_at_price);
        priceEl?.after(c);
      }
      const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      if (badgeEl) {
        badgeEl.hidden = false;
        badgeEl.textContent = `${pct}% OFF`;
      }
    } else {
      root.querySelector('[data-compare]')?.setAttribute('hidden', '');
      root.querySelector('[data-badge]')?.setAttribute('hidden', '');
    }

    if (atc) atc.disabled = !variant.available;
    if (atcLabel) {
      atcLabel.textContent = variant.available
        ? `ADD TO CART — ${money(variant.price)}`
        : 'SOLD OUT';
    }

    if (variant.featured_image) {
      const idx = slides.findIndex((s) => {
        const img = s.querySelector('img');
        return img && (img.src.includes(String(variant.featured_image.id)) || img.src.includes(variant.featured_image.src?.split('?')[0]?.slice(-40)));
      });
      // Prefer matching media by src fragment
      const mediaIndex = product.media?.findIndex((m) => m.id === variant.featured_media?.id || m.src === variant.featured_image.src);
      if (mediaIndex >= 0) setSlide(mediaIndex);
    }
  };

  root.querySelectorAll('[data-option-value][data-option-position]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const pos = Number(btn.dataset.optionPosition);
      const name = product?.options?.[pos - 1];
      root.querySelectorAll(`[data-option-position="${pos}"]`).forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      if (name) selected[name] = btn.dataset.optionValue;

      if (/color|colour/i.test(name || '')) {
        const label = root.querySelector('[data-color-label]');
        if (label) label.textContent = btn.dataset.optionValue;
      }
      updateBuybox(findVariant());
    });
  });

  /* ---------- Ajax ATC ---------- */
  const form = root.querySelector('[data-product-form]');
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const atc = root.querySelector('[data-add-to-cart]');
    const atcLabel = root.querySelector('[data-atc-label]');
    const prev = atcLabel?.textContent;
    atc?.classList.add('is-loading');
    if (atcLabel) atcLabel.textContent = 'ADDING…';

    try {
      const res = await fetch(window.Shopify?.routes?.root
        ? `${Shopify.routes.root}cart/add.js`
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: Number(root.querySelector('[data-variant-id]')?.value),
          quantity: 1,
        }),
      });
      if (!res.ok) throw new Error('Add failed');
      if (atcLabel) atcLabel.textContent = 'ADDED';
      const count = root.querySelector('[data-cart-count]');
      if (count) count.textContent = String(Number(count.textContent || 0) + 1);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(() => { if (atcLabel) atcLabel.textContent = prev; }, 1200);
    } catch (_) {
      if (atcLabel) atcLabel.textContent = 'TRY AGAIN';
      setTimeout(() => { if (atcLabel) atcLabel.textContent = prev; }, 1400);
    } finally {
      atc?.classList.remove('is-loading');
    }
  });

  /* ---------- Wishlist toggle ---------- */
  root.querySelectorAll('[data-wishlist]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const pressed = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
    });
  });

  /* ---------- Accordions ---------- */
  root.querySelectorAll('.zp-acc').forEach((acc) => {
    const trigger = acc.querySelector('.zp-acc-trigger');
    const panel = acc.querySelector('.zp-acc-panel');
    trigger?.addEventListener('click', () => {
      const open = acc.classList.contains('is-open');
      root.querySelectorAll('.zp-acc.is-open').forEach((other) => {
        if (other === acc) return;
        other.classList.remove('is-open');
        other.querySelector('.zp-acc-trigger')?.setAttribute('aria-expanded', 'false');
      });
      acc.classList.toggle('is-open', !open);
      trigger.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = false;
    });
  });

  /* ---------- Scroll reveals ---------- */
  const revealTargets = root.querySelectorAll(
    '.zp-story, .zp-fabric, .zp-complete, .zp-accordions, .zp-card'
  );
  revealTargets.forEach((el) => el.classList.add('zp-inview'));
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  revealTargets.forEach((el) => io.observe(el));
})();